var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAlignRightSimple = function SvgIconAlignRightSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 5.25a1 1 0 1 0-2 0v13.5a1 1 0 1 0 2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 7.25A1.75 1.75 0 0 0 1.25 9v6c0 .966.784 1.75 1.75 1.75h13.5A1.75 1.75 0 0 0 18.25 15V9a1.75 1.75 0 0 0-1.75-1.75zm.25 7.5v-5.5h13v5.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconAlignRightSimple;